export function renderScopes(scopes, andTranslation) {
  const first = scopes.slice(0, -2);
  const lastTwo = scopes.slice(-2);

  let scopesText = '';
  if (first.length > 0) {
    scopesText += `${first.join(', ')}, `;
  }

  if (lastTwo.length > 0) {
    scopesText += lastTwo.join(` ${andTranslation} `);
  }

  return scopesText;
}
